import React from 'react';
import { Typography, Box, Avatar } from '@mui/material';
import { Circle as CircleIcon, Shield as ShieldIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

/** What moderators did after a report: to the author, their post was removed, deleted or restored (with the
 *  reason); to the people who reported it, how their report was handled (interact/report/viewsets.py moderate). */
export default function ModerationNotificationCard({ notification, onMarkRead }) {
  const navigate = useNavigate();
  const p = notification.payload || {};
  const forAuthor = (p.kind || '').startsWith('post_');

  const open = () => {
    if (!notification.is_read && onMarkRead) onMarkRead();
    if (p.url) navigate(p.url);
  };

  return (
    <Box
      onClick={open}
      sx={{
        display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1.25, px: 2,
        borderBottom: '1px solid', borderColor: 'divider',
        backgroundColor: notification.is_read ? 'transparent' : 'action.hover',
        cursor: p.url ? 'pointer' : 'default', '&:hover': { backgroundColor: 'action.selected' },
      }}
    >
      <Avatar sx={{ width: 34, height: 34, mt: 0.25, bgcolor: forAuthor && p.kind !== 'post_restore' ? 'warning.main' : 'success.main', color: 'white' }}>
        <ShieldIcon sx={{ fontSize: 18 }} />
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2">
          {p.message || (forAuthor ? 'Moderators reviewed your post.' : 'Moderators reviewed your report.')}
        </Typography>
        {!forAuthor && p.excerpt && (
          <Typography variant="caption" color="text.secondary" display="block" noWrap>“{p.excerpt}”</Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          {formatDistanceToNow(new Date(notification.created), { addSuffix: true })}
        </Typography>
        {!notification.is_read && <CircleIcon sx={{ fontSize: 8, color: 'primary.main' }} />}
      </Box>
    </Box>
  );
}
